import { Environment } from './environment.type';

export const environment: Environment = {
  production: true,
  firebase: {
    projectId: 'jujuja-app',
    appId: '1:566409741692:web:8328677de6ce61021e10f9',  // Using working config from mobile app
    storageBucket: 'jujuja-app.appspot.com',
    apiKey: 'AIzaSyCu8cOJSPP3c8r1jIp5U8UwoqlpfWNJn-I',  // Working API key with billing
    authDomain: 'jujuja-app.firebaseapp.com',
    messagingSenderId: '566409741692',
    measurementId: 'G-4ZYZ0Z53VK',  // Using working measurement ID
  },
  baseUrlEven: 'https://apieven-nztnx5ow5q-uc.a.run.app',
  baseUrlOdd: 'https://apiodd-nztnx5ow5q-uc.a.run.app',
};
